import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import Vant from 'vant';
import 'vant/lib/index.css'
import './assets/style/style.less'
import './assets/style/common.less'
import './assets/style/init.less'
import { delete1, get, post } from './http/axios';
import {ElMessage} from 'element-plus'
import { createPinia } from 'pinia'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
const app = createApp(App);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(router).use(ElementPlus).use(Vant).use(createPinia()).mount('#app')
app.config.globalProperties.$message = ElMessage;
app.provide('$message', ElMessage)
app.config.globalProperties.$get = get;
app.config.globalProperties.$post = post;
app.config.globalProperties.$delete1 = delete1;
